import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../slice/userSlice";
import cartReducer from "../slice/cartSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    cart: cartReducer
  }
});

export default store;
